/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import styles from './input.element.scss';
export * from './input.element.js';
export * from './input-group.element.js';
export const inputStyles = styles;
